<script setup lang="ts">
import { ref } from 'vue';
import { useSchoolStore } from '@/stores/school';
import BreadCrumbs from '@/components/Utilities/BreadCrumbs.vue';

const { school } = useSchoolStore();

if (school === null) {
    throw new Error('No school selected');
}

const infoVisible = ref<boolean>(true);
</script>
<template>
    <div
        id="school-info"
        class="text-fsum-black"
    >
        <BreadCrumbs
            v-if="infoVisible"
            :bread-crumbs="[{ to: { name: 'schoolDirectory' }, label: 'School Directory'}]"
            current-page="School Information"
        />
        <header
            v-if="infoVisible"
            id="school-info-header"
        >
            <h1 class="q-pb-lg q-pt-lg q-mb-xs fsum-generic-header">
                {{ school?.name }}
            </h1>
        </header>
        <q-tabs
            v-if="infoVisible"
            indicator-color="red"
            class="q-mb-xl"
            no-caps
        >
            <q-route-tab
                name="school-profile"
                label="School Profile"
                :to="{ name: 'schoolProfile' }"
                :ripple="false"
                exact
            />
            <q-route-tab
                name="administrators"
                label="Administrators"
                :to="{ name: 'admins', params: { schoolSlug: school?.urlSlug } }"
                :ripple="false"
                exact
            />
        </q-tabs>
        <RouterView
            @update:info-visible="infoVisible = $event"
        />
    </div>
</template>
<style scoped>
#school-info {
    font-size: 16px;
    text-align: center;
}
:deep(.q-tab__label) {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
}
:deep(.q-tab--inactive .q-tab__indicator) {
    background-color: var(--fsum-gray);
    opacity: 100;
}
:deep(.q-tab--active .q-tab__label) {
    color: var(--fsum-dark-blue2);
}
:deep(.q-tab--inactive .q-tab__label) {
    color: var(--fsum-gray);
}
</style>
